module.exports = __webpack_public_path__ + "img/kirk-pic.bd726468.jpg";